module["exports"] = [
  "Brasil"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/pt_BR/address/default_country.js
 ** module id = 947
 ** module chunks = 0
 **/